/* hanbi.js : composants minimaux pour les sections portees (Splide officiel requis) */
(function(){
  class HanbiSlider extends HTMLElement{
    connectedCallback(){
      const g=(a,d)=>this.getAttribute(a)??d;
      const root=this.querySelector('[data-ref="main-slider"]'); if(!root||!window.Splide) return;
      let ppm=parseFloat(g('data-per-page-mobile',1)); if(ppm===1.8) ppm=1;
      const ppd=parseFloat(g('data-per-page-desktop',3));
      const opts={perPage:ppm,perMove:1,rewind:g('data-rewind')==='true',gap:g('data-gap',10)+'px',drag:true,snap:true,
        arrows:g('data-show-arrows-mobile')==='true'||g('data-show-arrows')==='true',pagination:g('data-show-pagination-mobile')==='true',
        autoplay:g('data-autoplay')==='true',interval:parseInt(g('data-autoplay-speed',4))*1000,autoHeight:true,mediaQuery:'min',direction:document.documentElement.dir==='rtl'?'rtl':'ltr',
        breakpoints:{750:{perPage:ppd,pagination:g('data-show-pagination')==='true',arrows:g('data-show-arrows')==='true'}}};
      this.slider=new Splide(root,opts);
      const th=this.querySelector('[data-ref="thumbnail-slider"]');
      if(th){this.thumbs=new Splide(th,{fixedWidth:90,fixedHeight:90,gap:10,rewind:false,pagination:false,isNavigation:true,direction:document.documentElement.dir==='rtl'?'rtl':'ltr',arrows:g('data-show-arrows-thumbnails')==='true',breakpoints:{750:{fixedWidth:70,fixedHeight:70}}});this.slider.sync(this.thumbs);}
      this.slider.mount(); if(this.thumbs) this.thumbs.mount();
    }
  }
  customElements.get('hanbi-slider')||customElements.define('hanbi-slider',HanbiSlider);
  class AccordionRow extends HTMLElement{
    connectedCallback(){const d=this.querySelector('details'); if(!d) return; const m=window.matchMedia('(max-width: 749px)').matches;
      d.open=(m&&this.hasAttribute('open-by-default-on-mobile'))||(!m&&this.hasAttribute('open-by-default-on-desktop'));}
  }
  customElements.get('accordion-row')||customElements.define('accordion-row',AccordionRow);
  class QuantitySelector extends HTMLElement{
    connectedCallback(){const i=this.querySelector('input[type=number]'); const b=this.querySelectorAll('button'); if(!i||b.length<2) return;
      b[0].addEventListener('click',e=>{e.preventDefault(); i.value=Math.max(parseInt(i.min||1),(parseInt(i.value)||1)-1); i.dispatchEvent(new Event('change',{bubbles:true}));});
      b[1].addEventListener('click',e=>{e.preventDefault(); i.value=(parseInt(i.value)||1)+1; i.dispatchEvent(new Event('change',{bubbles:true}));});}
  }
  customElements.get('quantity-selector')||customElements.define('quantity-selector',QuantitySelector);
  /* dropdown & popup: toggles simples */
  class DropdownComponent extends HTMLElement{
    connectedCallback(){const t=this.querySelector('[data-ref="dropdown-toggle"]'); if(!t) return;
      t.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();this.setAttribute('data-open',this.getAttribute('data-open')==='true'?'false':'true');});
      document.addEventListener('click',e=>{if(!this.contains(e.target)) this.setAttribute('data-open','false');});}
  }
  customElements.get('dropdown-component')||customElements.define('dropdown-component',DropdownComponent);
  class DialogComponent extends HTMLElement{
    connectedCallback(){const b=this.querySelector('[data-ref="popup-toggle"]'),m=this.querySelector('[data-ref="popup-modal"]'),c=this.querySelector('[data-ref="popup-close"]'); if(!m) return;
      b&&b.addEventListener('click',e=>{e.preventDefault();m.showModal();}); c&&c.addEventListener('click',e=>{e.preventDefault();m.close();});
      m.addEventListener('click',e=>{const r=m.getBoundingClientRect(); if(!(r.top<=e.clientY&&e.clientY<=r.bottom&&r.left<=e.clientX&&e.clientX<=r.right)) m.close();});}
  }
  customElements.get('dialog-component')||customElements.define('dialog-component',DialogComponent);
})();
/* ---- PDP : bundle picker + add to cart -> Dawn cart drawer ---- */
(function(){
  class HanbiBundle extends HTMLElement{
    connectedCallback(){
      this.querySelectorAll('input[type=radio]').forEach(r=>r.addEventListener('change',()=>this.apply()));
      this.apply();
    }
    apply(){
      const sel=this.querySelector('input[type=radio]:checked'); if(!sel) return;
      this.querySelectorAll('.hanbi-bundle__opt').forEach(o=>o.classList.toggle('is-selected',o.contains(sel)));
      const form=this.closest('form'); if(!form) return;
      const q=form.querySelector('input[name=quantity]'); if(q) q.value=sel.value;
      const opt=sel.closest('.hanbi-bundle__opt'); form.dataset.extras=opt.getAttribute('data-extras')||'[]';
    }
  }
  customElements.get('hanbi-bundle')||customElements.define('hanbi-bundle',HanbiBundle);
  class HanbiProductForm extends HTMLElement{
    connectedCallback(){
      const form=this.querySelector('form'); if(!form) return;
      form.addEventListener('submit',async e=>{
        e.preventDefault();
        const btn=form.querySelector('[data-ref="add-to-cart-button"]'); btn&&btn.classList.add('loading');
        const id=form.querySelector('input[name=id]').value, qty=parseInt(form.querySelector('input[name=quantity]')?.value||1);
        let items=[{id:parseInt(id),quantity:qty}];
        try{ (JSON.parse(form.dataset.extras||'[]')).forEach(x=>{ if(x.id) items.push({id:parseInt(x.id),quantity:x.qty||1}); }); }catch(err){}
        try{
          const res=await fetch(window.Theme.routes.cart_add_url.replace(/\.js$/,'')+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items,sections:'cart-drawer,cart-icon-bubble',sections_url:window.location.pathname})});
          const json=await res.json();
          if(json.status){ alert(json.description||json.message); return; }
          const cd=document.querySelector('cart-drawer');
          if(cd&&cd.renderContents){ cd.renderContents(json); } else { window.location.href=window.Theme.routes.cart_url; }
        }catch(err){ window.location.href=window.Theme.routes.cart_url; }
        finally{ btn&&btn.classList.remove('loading'); }
      });
    }
  }
  customElements.get('hanbi-product-form')||customElements.define('hanbi-product-form',HanbiProductForm);
})();
